import { Row } from '../Grid/Grid';

function LoadingWrapper({ children, loadingComponent, loading }: LoadingWrapperProps) {
  return (
    <>
      {loading && <Row>{loadingComponent}</Row>}
      {!loading && children}
    </>
  );
}

export default LoadingWrapper;
